// Central registry of all blog articles.
// To add a new article: create a file in this folder (same shape as the others),
// import it below and add one entry to ARTICLE_META with its publish date.

import whatIsCrm from "./what-is-crm-software-complete-guide";
import leadManagement from "./lead-management-system-complete-guide";
import lmsVsCrm from "./lms-vs-crm-which-do-you-need";
import crmSmallBusiness from "./crm-for-small-business-india";
import whatsappCrm from "./whatsapp-crm-automation-guide";
import clickToCall from "./ivr-click-to-call-crm-integration";
import crmEducation from "./crm-for-education-admissions";
import crmHealthcare from "./healthcare-crm-patient-engagement";
import crmRealEstate from "./real-estate-crm-lead-follow-up";
import pipeline from "./sales-pipeline-management-best-practices";

// ISO dates (YYYY-MM-DD). Edit these to your real publish dates.
const ARTICLE_META = [
  { article: whatIsCrm, published: "2026-10-27" },
  { article: leadManagement, published: "2026-10-25" },
  { article: lmsVsCrm, published: "2026-10-22" },
  { article: crmSmallBusiness, published: "2026-10-19" },
  { article: whatsappCrm, published: "2026-10-16" },
  { article: clickToCall, published: "2026-10-13" },
  { article: crmEducation, published: "2026-10-10" },
  { article: crmHealthcare, published: "2026-10-07" },
  { article: crmRealEstate, published: "2026-10-04" },
  { article: pipeline, published: "2026-10-01" },
];

const countWords = (a) =>
  JSON.stringify([a.intro, a.sections, a.faq, a.conclusion])
    .replace(/\]\([^)]*\)/g, " ")
    .replace(/[^A-Za-z0-9' ]+/g, " ")
    .split(/\s+/)
    .filter(Boolean).length;

export const ARTICLES = ARTICLE_META.map(({ article, published }) => {
  const wordCount = countWords(article);
  return {
    ...article,
    published,
    modified: published,
    wordCount,
    readTime: `${Math.max(1, Math.ceil(wordCount / 200))} min read`,
  };
}).sort((a, b) => (a.published < b.published ? 1 : -1));

export const getArticle = (id) => ARTICLES.find((a) => a.id === id);

export const formatDate = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-IN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
